// src/jsx/axiosClient.js
import axios from "axios";

const api = axios.create({
    baseURL: "https://ccvai.chalachitravaachana.org/",
    headers: {
        "Content-Type": "multipart/form-data",
    },
    withCredentials: true,
});

function getStoredSession() {
    try {
        return JSON.parse(localStorage.getItem("userSession"));
    } catch {
        return null;
    }
}

function clearSessionAndRedirect() {
    localStorage.removeItem("userSession");
    localStorage.removeItem("access_token");
    localStorage.removeItem("name");

    if (window.location.pathname !== "/login") {
        window.location.href = "/login";
    }
}

api.interceptors.request.use(
    (config) => {
        const sessionData = getStoredSession();

        if (sessionData?.access_token) {
            config.headers.Authorization = `Bearer ${sessionData.access_token}`;
        }

        return config;
    },
    (error) => Promise.reject(error)
);

api.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        if (error.response?.status !== 401 || originalRequest?._retry) {
            return Promise.reject(error);
        }

        originalRequest._retry = true;

        try {
            const res = await axios.post(
                "https://ccvai.chalachitravaachana.org/refresh",
                {},
                { withCredentials: true }
            );

            const accessToken = res.data?.access_token;

            if (!accessToken) {
                throw new Error("Refresh response did not include an access token.");
            }

            const currentSession = getStoredSession() || {};
            const updatedSession = {
                ...currentSession,
                access_token: accessToken,
                expiresAt: Date.now() + 60 * 60 * 1000,
            };

            localStorage.setItem("userSession", JSON.stringify(updatedSession));
            originalRequest.headers.Authorization = `Bearer ${accessToken}`;

            return api(originalRequest);
        } catch (refreshError) {
            clearSessionAndRedirect();
            return Promise.reject(refreshError);
        }
    }
);

export default api;